import { PublicLayout } from '@/components/Layout';
import { motion } from 'framer-motion';
import { Shield, Trash2, Mail, Lock } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <PublicLayout>
      <section className="py-16 md:py-24 bg-terracotta-light/20">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-display text-4xl md:text-5xl text-charcoal mb-4" data-testid="privacy-title">
              Politique de confidentialité
            </h1>
            <p className="text-stone">
              Protection de vos données personnelles
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-padding">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="prose prose-stone max-w-none"
          >
            <div className="card-elegant mb-8">
              <div className="flex items-start gap-4 mb-4">
                <Shield className="w-8 h-8 text-terracotta flex-shrink-0" />
                <div>
                  <h2 className="font-display text-xl text-charcoal mt-0 mb-2">Responsable du traitement</h2>
                  <p className="text-stone text-sm m-0">
                    Mélanie & Cédric, dans le cadre de l'organisation de leur mariage prévu le 5 septembre 2026.
                  </p>
                </div>
              </div>
            </div>

            <div className="card-elegant mb-8">
              <h2 className="font-display text-xl text-charcoal mb-4">Données collectées</h2>
              <p className="text-stone text-sm mb-4">
                Dans le cadre de la gestion des invitations et de l'organisation du mariage, nous collectons les données suivantes :
              </p>
              <ul className="text-stone text-sm space-y-2">
                <li>Nom de famille</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone (optionnel)</li>
                <li>Prénoms des participants (adultes et enfants)</li>
                <li>Informations sur les allergies ou régimes alimentaires</li>
                <li>Préférences d'hébergement</li>
              </ul>
            </div>

            <div className="card-elegant mb-8">
              <h2 className="font-display text-xl text-charcoal mb-4">Finalité du traitement</h2>
              <p className="text-stone text-sm">
                Vos données sont utilisées exclusivement pour :
              </p>
              <ul className="text-stone text-sm space-y-2 mt-4">
                <li>Gérer les confirmations de présence</li>
                <li>Organiser les hébergements</li>
                <li>Adapter le repas en fonction des régimes alimentaires</li>
                <li>Vous envoyer des informations pratiques concernant le mariage</li>
              </ul>
            </div>

            <div className="card-elegant mb-8">
              <div className="flex items-start gap-4 mb-4">
                <Lock className="w-8 h-8 text-terracotta flex-shrink-0" />
                <div>
                  <h2 className="font-display text-xl text-charcoal mt-0 mb-2">Sécurité des données</h2>
                  <p className="text-stone text-sm m-0">
                    Vos données sont stockées de manière sécurisée. Aucune donnée bancaire n'est conservée sur notre site. 
                    Les paiements sont effectués directement via les services tiers (PayPal, Paylib, virement bancaire).
                  </p>
                </div>
              </div>
            </div>

            <div className="card-elegant mb-8">
              <div className="flex items-start gap-4 mb-4">
                <Trash2 className="w-8 h-8 text-terracotta flex-shrink-0" />
                <div>
                  <h2 className="font-display text-xl text-charcoal mt-0 mb-2">Vos droits</h2>
                  <p className="text-stone text-sm mb-4">
                    Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
                  </p>
                  <ul className="text-stone text-sm space-y-2 m-0">
                    <li>Droit d'accès à vos données</li>
                    <li>Droit de rectification</li>
                    <li>Droit à l'effacement</li>
                    <li>Droit à la portabilité</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-elegant">
              <div className="flex items-start gap-4">
                <Mail className="w-8 h-8 text-terracotta flex-shrink-0" />
                <div>
                  <h2 className="font-display text-xl text-charcoal mt-0 mb-2">Contact</h2>
                  <p className="text-stone text-sm m-0">
                    Pour toute demande concernant vos données personnelles, vous pouvez nous contacter par email.
                    Vos données seront supprimées après le mariage, sauf demande anticipée de votre part.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </PublicLayout>
  );
};

export default PrivacyPage;
